import { createAction, props } from '@ngrx/store';
import * as authActions from './auth.actions'
import { AdminCountry, AuthUser, CompanyProfile } from './auth.interface';

export const login = createAction(
    '[Auth Module] login user',
    props<{ credentials: { email: string, password: string, otp?: string } }>()
);

export const loginSuccessful = createAction(
    '[Auth Module] login successful'
);

export const loginFailed = createAction(
    '[Auth Module] login failed',
    props<{message: string, code: number}>()
);

export const otpRequired = createAction(
    '[Auth Module] otp required'
);

export const generateOtp = createAction(
    '[Auth Module] generate otp',
    props<{ credentials: { email: string, password: string } }>()
);

export const generateOtpSuccess = createAction(
    '[Auth Module] STATUS: generate otp success'
);

export const generateOtpFailed = createAction(
    '[Auth Module] STATUS: generate otp failed'
);

export const userNotActivated = createAction(
    '[Auth Module] user not active',
    props<{ response: any }>()
);

// export const fetchAdminCountries = createAction(
//     '[Login Module] READ: fetch admin countries'
// );
// export const fetchAdminFailed = createAction(
//     '[Login Module] fetch admin countries failed'
// );

// export const setAdminCountry = createAction(
//     '[Login Module] Set Admin Country',
//     props<{adminCountry: AdminCountry}>()
// );

// export const setCountries = createAction(
//     '[Login Module] Set Countries',
//     props<{ countries: AdminCountry[] }>()
// );

export const logout = createAction(
    '[Auth Module] logout'
);

export const fetchAuthUser = createAction(
    "[Auth Module] fetch authenticated user"
)

export const fetchAuthUserSuccess = createAction(
    "[Auth Module] fetch authenticated user success"
)

export const fetchAuthUserFailed = createAction(
    "[Auth Module] fetch authenticated user failed"
)

export const setAuthUser = createAction(
    "[Auth Module] set authenticated user",
    props<{ authUser :  AuthUser}>()
)



export const fetchEntityTypes = createAction(
    '[Auth Module] fetch entity types',
    props<{ countryCode :  string}>()
)

export const fetchEntityTypesFailed = createAction(
    '[Auth Module] STATUS: fetch entity types failed'
)

export const fetchEntityTypesSuccess = createAction(
    '[Auth Module] STATUS: fetch entity types success',
    props<{entityTypes}>()
)


export const fetchBusinessTypes = createAction(
    '[Auth Module] fetch business types'
)

export const fetchBusinessTypesFailed = createAction(
    '[Auth Module] STATUS: fetch business types failed'
)

export const fetchBusinessTypesSuccess = createAction(
    '[Auth Module] STATUS: fetch business types success',
    props<{businessTypes}>()
)


export const fetchTransactionTypes = createAction(
    '[Auth Module] fetch transaction types'
)

export const fetchTransactionTypesFailed = createAction(
    '[Auth Module] STATUS: fetch transaction types failed'
)

export const fetchTransactionTypesSuccess = createAction(
    '[Auth Module] STATUS: fetch transaction types success',
    props<{transactionTypes}>()
)


export const createMerchant = createAction(
    '[Auth Module] create merchant',
    props<{requestPayload}>()
)

export const createMerchantFailed = createAction(
    '[Auth Module] STATUS: create merchant failed'
)

export const createMerchantSuccess = createAction(
    '[Auth Module] STATUS: create merchant success',
    props<{response: any}>()
)

export const requestPasswordReset = createAction(
    '[Auth Module] request password reset',
    props<{payload}>()
)

export const requestPasswordResetSuccess = createAction(
    '[Auth Module] STATUS: request password success',
    props<{payload}>()
)

export const requestPasswordResetFailed = createAction(
    '[Auth Module] STATUS: request password reset failed'
)

export const resetPassword = createAction(
    '[Auth Module] reset password',
    props<{payload}>()
)
 export const resetPasswordSuccess = createAction(
    '[Auth Module] STATUS: reset password success',
    props<{payload}>()
 )

 export const resetPasswordFailed = createAction(
    '[Auth Module] STATUS: reset password failed'
 )


export const fetchCompanyProfile = createAction(
    '[Auth Module] fetch company profile',
    props<{companyNumber: string}>()
)

export const fetchCompanyProfileFailed = createAction(
    '[Auth Module] STATUS: fetch company profile failed'
)

export const fetchCompanyProfileSuccess = createAction(
    '[Auth Module] STATUS: fetch company profile success',
    props<{companyProfile: CompanyProfile}>()
)
